<template>
  <b-nav class="nav-toggled pap">
    <span class='button-pap'>
      <label @click="openPAP" :title="$t('papHover')">{{$t('pap')}}</label>
    </span>
    <b-modal
      id="confirmSaveFlowchart"
      ok-variant="danger"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="confirmSaveArea"
      title="Confirmar Modificações "
      :no-close-on-backdrop="true"
    >
      {{ $t('deseja-salvar-as-alteracoes-realizadas-no-diagrama') }}
    </b-modal>
  </b-nav>
</template>

<script>
import axios from 'axios'
import { urlMainAPI, defaultSuccess } from "@/global";
  export default {
    name: "PAPDropdown",

    data() {
      return {
        showPlay: false,
        showStop: false,
      }
    },

    methods: {
      openPAP() {
        var url = window.location.pathname

        if (!url.match(/.areaspap/)){
          this.$router.push({ name: "areaspap" });
          document.querySelectorAll(".actionSimulation-navbar").forEach(el => el.style.display = "block")
          this.showPlay = true;
        }
      },

    confirmSaveArea(){
      let flowchart = this.$store.state.flowchartStructure;

      const url = `${urlMainAPI}/saveflowchart`;
      axios
        .post(url, flowchart)
        .then((res) => {
          defaultSuccess(res.data);
        })
        .catch(console.log);
    },
  },
  created(){}
  }
</script>

<style scoped>

</style>